import { Controller } from 'stimulus';

export default class extends Controller {
  toggle() {
    $('.importFormLink').toggle();
    $('#importForm').toggle();
  }
}
